// Small shared UI primitives for public pages.
import { Link } from "react-router-dom";

export function PageHero({ eyebrow, title, subtitle, bg }) {
  return (
    <section className="relative overflow-hidden border-b border-slate-800" data-testid="page-hero">
      <div className="absolute inset-0 grid-lines opacity-40" />
      {bg && (
        <div className="absolute inset-0">
          <img src={bg} alt="" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#030712]/70 via-[#030712]/85 to-[#030712]" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-extrabold tracking-tight text-white max-w-4xl leading-[1.05]">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-slate-400 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, right }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
      <div>
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-white tracking-tight">{title}</h2>
      </div>
      {right}
    </div>
  );
}

export function Loader({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-32" data-testid="loader">
      <div className="flex items-center gap-3 text-slate-500">
        <span className="w-4 h-4 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
        <span className="font-mono text-sm">{label}…</span>
      </div>
    </div>
  );
}

export function CTASection() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="relative overflow-hidden rounded-3xl border border-emerald-500/25 bg-gradient-to-br from-emerald-950/40 to-slate-950 p-10 lg:p-16 emerald-glow">
        <div className="absolute inset-0 grid-lines opacity-30" />
        <div className="relative max-w-2xl">
          <p className="eyebrow mb-4">Partner With Us</p>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-white mb-4">
            Building the next generation of global ventures.
          </h2>
          <p className="text-slate-300 mb-8">
            Whether you're an investor, partner, or looking to join our team — let's start a conversation.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/contact" data-testid="cta-contact-btn" className="btn-emerald px-6 py-3 rounded-full">
              Get in Touch
            </Link>
            <Link to="/careers" data-testid="cta-careers-btn" className="px-6 py-3 rounded-full border border-slate-700 text-slate-200 hover:border-emerald-500/50 transition-colors">
              Explore Careers
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
